import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import { fetchData } from './service/index'
import gql from './graphql/graphql'

export function createStore() {
  return new Vuex.Store({
    state: {
      nav: [
        {
          name: "首页",
          label: "HOME",
          path: "/",
          color: "#FF5196",
          id: 1
        },
        // {
        //   name: "拍摄样片",
        //   label: "TAKE PHOTOS",
        //   path: "/meinvtupian/",
        //   imgUrl: "wap/home-album.jpg",
        //   color: "#FF69A5",
        //   id: 2
        // },
        // {
        //   name: "内衣商城",
        //   label: "LINGERIE MALL",
        //   path: "/shop/",
        //   imgUrl: "wap/home-shoot.jpg",
        //   color: "#FF82B4",
        //   id: 3
        // },
        // {
        //   name: "参与模特",
        //   label: "IN MODEL",
        //   path: "/meinv/",
        //   imgUrl: "wap/home-model.png",
        //   color: "#FF9BC3",
        //   id: 4
        // },
        // {
        //   name: "主题拍摄",
        //   label: "THEME",
        //   path: "/mote/",
        //   imgUrl: "wap/home-theme.png",
        //   color: "#FFB4D2",
        //   id: 5
        // },
        {
          name: "尤果网拍摄服务",
          label: "SHOOTING",
          path: "/help/about.html",
          color: "#FFCDE1",
          id: 6
        }
      ],
      platform: ['PC', 'WAP'], // 运行平台
      contentType: ['ALBUM', 'COMMODITY'], // 内容类型
      home: { // 首页数据
        banner: [],
        newAlumList: [],
        labels: []
      },
      shopData: {}, // 内衣商城数据
      shopDetail: { // 商城详情数据
        title: '暂无',
        price: 0,
        colors: [],
        description: '暂无',
        coverPhoto: {
          url: ''
        },
        commodityPhotos: [],
        similarCommodityList: []
      },
      photoData: {  // 写真数据
        total: 0,
        list: [],
        labels: []
      },
      photoDetail: {
        detail: {},
        newAlumList: []
      },
      modelData: {   // 模特数据
        idList: [],
        total: 0,
        list: [],
        topLabel: [],
        bottomLabel: []
      },
      modelDetail: {
        info: {},
        albumList: [],
        labels: []
      },
      moteData: { // 参与拍摄数据
        total: 0,
        list: []
      },
      moteDetail: {
        info: {},
        albumList: [],
        momentList: [],
        newsList: []
      },
      newsDetail: {},
      dynamicData: {
        name: '',
        list: []
      },
      newsData: [],
      params: { // 商品，专辑, 模特接口参数
        query: '',
        variables: {
          distributionPlatform: 'WAP',
          cubeListCategory: 'DISCOVERY',
          type: 'ALBUM',
          page: 1,
          pageSize: 20
        }
      }
    },

    getters: {
      homeData: state => {
        return state.home
      },
      photoData(state) {
        return state.photoData;
      },
      photoDetail: state => {
        return state.photoDetail
      },
      shopData: state => {
        return state.shopData
      },
      shopDetail: state => {
        return state.shopDetail
      },
      modelData: state => {
        return state.modelData
      },
      modelDetail: state => {
        return state.modelDetail
      },
      moteData: state => {
        return state.moteData
      },
      moteDetail: state => {
        return state.moteDetail
      },
      newsDetail: state => {
        return state.newsDetail
      },
      dynamicData: state => {
        return state.dynamicData
      },
      newsData: state => {
        return state.newsData
      },
      linkNav: state => {
        return state.nav.slice(1, 5);
      },
      menuNav: state => {
        return state.nav;
      }
    },

    actions: {
      // 获取首页banner图片, 最新专辑列表, 美女图片分类
      getHomeData({ commit }, param) {
        return fetchData(param).then(response => {
          const data = {
            banner: [],
            newAlumList: [],
            labels: []
          };
          if (response.data.getWebBanners) {
            data.banner = response.data.getWebBanners
          }
          if (response.data.getWebCubesByType) {
            data.newAlumList = response.data.getWebCubesByType.list
          }
          if (response.data.getWebTextLabelConfig) {
            data.labels = response.data.getWebTextLabelConfig
          }

          commit('setHomeData', data);
        });
      },
      // 切换最新写真列表
      changeLastAlbum({ commit }, param) {
        return fetchData(param).then(response => {
          const data = { newAlumList: [] };
          data.newAlumList = response.data.getWebCubesByType.list;
          commit('setLastAlbum', data);
        });
      },
      // 获取商品列表
      getShopList({ commit }, param) {
        return fetchData(param).then(response => {
          commit('setShopList', response.data.getWebCubesByType);
        });
      },
      // 通过 id 获取商品详情信息
      getShopDetailById({ commit }, id) {
        const param = {
          query: gql.GET_SHOP_DETAIL_BY_ID,
          variables: {
            id,
            type: this.state.contentType[1],
          }
        };
        return fetchData(param).then(response => {
          const data = response.data.getCubeByTypeAndID.commodity;
          if (data) {
            commit('setShopDetail', data);
          }
        });
      },
      // 获取写真列表
      getPhotoList({ commit }, param) {
        return fetchData(param).then(response => {
          const data = response.data.getWebCubesByType ||
            response.data.getWebCubeListByLabelWithPlatform;
          const labels = response.data.getWebTextLabelConfig;

          if (data) {
            data.labels = labels || [];
            commit('setPhotoList', data);
          }
        });
      },
      // 通过 contentId 获取专辑详情数据
      getDetailById({ commit }, id) {
        const param = { ...this.state.params };
        param.query = gql.GET_PHOTO_DETAIL_BY_ID;
        param.variables.contentId = id;
        param.variables.pageSize = 4;

        return fetchData(param).then(response => {
          const data = {
            detail: response.data.getCubeByTypeAndContentID || {},
            newAlumList: response.data.getWebCubesByType.list || []
          };
          commit('setPhotoDetail', data);
        });
      },
      // 获取模特列表
      getModelList({ commit }) {
        const param = {
          query: gql.GET_MODEL_ID_LIST,
          variables: {
            isSpecial: false,
            distributionPlatform: "WAP"
          }
        };
        return fetchData(param).then(response => {
          const idList = response.data.getModelListByContentPublishTime;
          const total = idList && idList.length > 0 ? idList.length : 0;

          commit('setModelData', { total, idList })

          // 根据idList 请求对应page的模特列表
          const variables = this.state.params.variables;
          const param = {
            query: gql.GET_MODEL_DATA,
            variables: {
              userIdList: idList.slice((variables.page - 1) * variables.pageSize,
                (variables.page - 1) * variables.pageSize + variables.pageSize),
              level: 0,
              labelPage: 1,
              labelPageSize: 1000
            },
          };
          return fetchData(param)
        }).then(res => {
          const list = res.data.getPersonListByIdList || [];
          const labels = res.data.getAllLabels || [];

          commit('setModelData', {
            list,
            topLabel: labels.filter(item => {
              return 1 === item.level && !item.deprecated && item.labelType === "PERSON"
            }),
            bottomLabel: labels.filter(item => {
              return 2 === item.level && !item.deprecated && item.labelType === "PERSON"
            })
          })
        });
      },
      // 通过标签获取模特数据
      getModeListByLabel({ commit }, data) {
        // 获取标签id
        const labelParam = {
          query: gql.GET_TEXT_LABEL_BY_PINYIN,
          variables: {
            pinyin: data.pinyin,
            type: "PERSON"
          }
        };
        return fetchData(labelParam).then(res => {
          const param = {
            query: gql.GET_MODE_DATA_BY_LABEL,
            variables: {
              labelId: res.data.getTextLabelByPinyinAndType.id,
              distributionPlatform: 'WAP',
              type: 'MODEL',
              page: this.state.params.variables.page,
              pageSize: 20,
              level: 0,
              labelPage: 1,
              labelPageSize: 1000
            }
          };
          return fetchData(param);
        }).then(res => {
          // 通过标签id 获取模特列表数据
          const list = res.data.getWebCubeListByLabelWithPlatform.list.map(item => {
            return { ...item.person }
          }) || [];
          const total = res.data.getWebCubeListByLabelWithPlatform.total || 0;
          const labels = res.data.getAllLabels || [];

          commit('setModelData', {
            list,
            total,
            topLabel: labels.filter(item => {
              return 1 === item.level && !item.deprecated && item.labelType === "PERSON"
            }),
            bottomLabel: labels.filter(item => {
              return 2 === item.level && !item.deprecated && item.labelType === "PERSON"
            })
          })
        });
      },

      // 获取模特详情页面（modelDetail）数据
      getModelDetail({ commit }, name) {
        const param = {
          query: gql.GET_MODEL_DETAIL,
          variables: {
            pinyin: name,
            level: 0,
            labelPage: 1,
            labelPageSize: 1000
          },
        };
        return fetchData(param).then(response => {
          const labels = response.data.getAllLabels || [];
          commit('setModelDetail', {
            info: response.data.getModelByPinyin || {},
            labels: labels.filter(item => {
              return !item.deprecated && item.labelType === "PERSON"
            })
          });

          const albumParam = {
            query: gql.GET_MODEL_ALBUM_LIST,
            variables: {
              momentsOnly: false,
              worksOnly: true,
              page: 1,
              pageSize: 5,
              userId: response.data.getModelByPinyin.basic.id,
              platform: 'WAP'
            }
          };
          return fetchData(albumParam)
        }).then(res => {
          commit('setModelDetail', {
            albumList: res.data.getCubesByUserId || []
          })
        })
      },

      // 获取参与拍摄页面（mote）数据
      getMoteList({ commit }) {
        const param = {
          query: gql.GET_MOTE_ID_LIST
        };

        return fetchData(param).then(response => {
          const idList = response.data.getSpecialModelIdList;
          const total = idList && idList.length > 0 ? idList.length : 0;

          commit('setMoteData', { total });

          // 根据idList 请求对应page的参与拍摄模特列表
          const variables = this.state.params.variables;
          const param = {
            query: gql.GET_MOTE_DATA,
            variables: {
              userIdList: idList.slice((variables.page - 1) * variables.pageSize,
                (variables.page - 1) * variables.pageSize + variables.pageSize),
            },
          };
          return fetchData(param)
        }).then(res => {
          const list = res.data.getPersonListByIdList || [];

          commit('setMoteData', { list })
        });
      },

      // 获取参与拍摄详情页面（moteDetail）数据
      getMoteDetail({ commit }, name) {
        const param = {
          query: gql.GET_MOTE_DETAIL,
          variables: {
            pinyin: name
          }
        };
        return fetchData(param).then(response => {
          const info = response.data.getModelByPinyin;
          commit('setMoteDetail', { info });

          const albumParam = {
            query: gql.GET_MOTE_DETAIL_ALBUM,
            variables: {
              page: 1,
              pageSize: 20,
              momentsOnly: false,
              worksOnly: true,
              modelId: info.basic.id,
              platform: "WAP"
            },
          };
          const newsParam = {
            query: gql.GET_MOTE_DETAIL_NEWS,
            variables: {
              page: 1,
              pageSize: 2,
              modelId: info.basic.id
            },
          };
          const momentParam = {
            query: gql.GET_MOTE_DETAIL_MOMENT,
            variables: {
              page: 1,
              pageSize: 5,
              momentsOnly: true,
              worksOnly: false,
              modelId: info.basic.id
            },
          };
          const request = [fetchData(albumParam), fetchData(momentParam), fetchData(newsParam)];

          return Promise.all(request)
        }).then(res => {
          const albumList = res[0].data.getCubesByUserId || [];
          const momentList = res[1].data.getCubesByUserId || [];
          const newsList = res[2].data.getArticleByModelId.list || [];

          commit('setMoteDetail', { momentList, albumList, newsList })
        });
      },
      // 通过 numberId 获取资讯详情
      getNewsDetail({ commit }, id) {
        const param = {
          query: gql.GET_NEWS_DETAIL,
          variables: {
            numberId: id
          }
        };

        return fetchData(param).then(res => {
          commit('setNewsDetail', res.data.getArticleByNumberId);
        });
      },
      // 获取动态数据列表
      getDynamicData({ commit }, name) {
        const param = {
          query: gql.GET_MODELID_BY_PINYIN,
          variables: {
            pinyin: name
          }
        };

        return fetchData(param).then(res => {
          const id = res.data.getModelByPinyin.basic.id;
          commit('setDynamicData', { name: res.data.getModelByPinyin.basic.nickName });
          const momentParam = {
            query: gql.GET_MOTE_DETAIL_MOMENT,
            variables: {
              page: 1,
              pageSize: 30,
              momentsOnly: true,
              worksOnly: false,
              modelId: id
            },
          };

          return fetchData(momentParam);
        }).then(response => {
          commit('setDynamicData', { list: response.data.getCubesByUserId });
        })
      },
      // 获取资讯数据列表
      getNewsData({ commit }, name) {
        const param = {
          query: gql.GET_MODELID_BY_PINYIN,
          variables: {
            pinyin: name
          }
        };

        return fetchData(param).then(res => {
          const id = res.data.getModelByPinyin.basic.id;
          const newsParam = {
            query: gql.GET_MOTE_DETAIL_NEWS,
            variables: {
              page: 1,
              pageSize: 20,
              modelId: id
            },
          };

          return fetchData(newsParam);
        }).then(response => {
          commit('setNewsData', response.data.getArticleByModelId.list);
        })
      },
      // 通过 label pinyin 获取label信息
      getLabelByPinyin({ commit }, param) {
        return fetchData(param);
      }
    },

    mutations: {
      setHomeData(state, data) {
        state.home = { ...data };
      },
      setLastAlbum(state, data) {
        state.home = Object.assign(state.home, data);
      },
      setShopList(state, data) {
        state.shopData = { ...data };
      },
      setShopDetail(state, data) {
        state.shopDetail = { ...data }
      },
      setPhotoList(state, data) {
        state.photoData = { ...data };
      },
      setPhotoDetail(state, data) {
        state.photoDetail = { ...data }
      },
      setModelData(state, data) {
        state.modelData = Object.assign(state.modelData, data);
      },
      setModelDetail(state, data) {
        state.modelDetail = Object.assign(state.modelDetail, data);
      },
      setMoteData(state, data) {
        state.moteData = Object.assign(state.moteData, data);
      },
      setMoteDetail(state, data) {
        state.moteDetail = Object.assign(state.moteDetail, data);
      },
      setNewsDetail(state, data) {
        state.newsDetail = { ...data }
      },
      setDynamicData(state, data) {
        state.dynamicData = Object.assign(state.dynamicData, data);
      },
      setNewsData(state, data) {
        state.newsData = [...data]
      }
    }
  })
}






// WEBPACK FOOTER //
// ./src/store.js